






















import {
  computed,
  defineComponent,
  ref,
  useStore,
} from '@nuxtjs/composition-api'
import HeaderNextMenu from './HeaderNextMenu.vue'
import HeaderNextSkeleton from './HeaderNextSkeleton.vue'
import { mapHeaderButtons } from './helpers'
import { HeaderInfo } from '@/contracts/Settings'

export default defineComponent({
  name: 'HeaderNext',
  components: { HeaderNextMenu, HeaderNextSkeleton },
  setup() {
    const store = useStore()
    const height = ref<number | null>(null)

    const headerInfo = computed(
      () => store.getters['settings/headerInfo'] as HeaderInfo | undefined
    )
    const buttons = computed(() => headerInfo.value?.buttons)
    const hasData = computed(() => !!headerInfo.value && !!buttons.value)

    const leftList = computed(() => mapHeaderButtons(buttons.value?._left))
    const rightList = computed(() => mapHeaderButtons(buttons.value?._right))
    const mobileList = computed(() => mapHeaderButtons(buttons.value?._mobile))
    const hasRibbon = computed(() => mobileList.value.length > 0)

    const spacerStyle = computed(() =>
      height.value === null ? undefined : { height: `${height.value}px` }
    )
    const onHeight = (value: number): void => {
      height.value = value
    }

    return {
      headerInfo,
      hasData,
      leftList,
      rightList,
      mobileList,
      hasRibbon,
      spacerStyle,
      onHeight,
    }
  },
})
